import * as moment from 'moment-mini-ts'

export default class EnergyCalculation {
    static soldSensorsPerDay = 5479 // pcs
    static pricePerSensor = 110 // €
    static energyPrice = 0.25 // €
    static startDate = moment("2022-07-25")
    static Co2CompisitionOfTree = 12.5 // kg 
    static powerInCo2 = 0.275 // kg European avg 2021 https://de.statista.com/statistik/daten/studie/1009521/umfrage/co2-emissionen-durch-stromerzeugung-in-der-eu/
    static overwriteEnergySavingPerYear = null // kann über den Div Container in der index.html gesetzt werden und überschreibt die applications Berechnung

    static applications = [
        {
            name: "office",
            weighting: 0.2,
            electricPower: 28,
            luminiaresPerSensor: 6,
            burningTimePerYear: 2000,
            saving: 0.5
        },
        {
            name: "industry",
            weighting: 0.2,
            electricPower: 57,
            luminiaresPerSensor: 5,
            burningTimePerYear: 4160,
            saving: 0.2
        },
        {
            name: "warehouse",
            weighting: 0.2,
            electricPower: 57,
            luminiaresPerSensor: 7.5,
            burningTimePerYear: 2600,
            saving: 0.5
        },
        {
            name: "garages",
            weighting: 0.2,
            electricPower: 16,
            luminiaresPerSensor: 6,
            burningTimePerYear: 8760,
            saving: 0.8
        },
        {
            name: "schools",
            weighting: 0.2,
            electricPower: 28,
            luminiaresPerSensor: 9,
            burningTimePerYear: 1600,
            saving: 0.3
        }
    ]

    static setEnergyPrice(newPrice) {
        EnergyCalculation.energyPrice = newPrice
        return EnergyCalculation.energyPrice
    }

    static getEnergyPrice() {
        return EnergyCalculation.energyPrice
    }

    static overwriteSensorSaving(value) {
        EnergyCalculation.overwriteEnergySavingPerYear = value
    }

    static setStartDate(date) {
        //console.log(date)
        EnergyCalculation.startDate = moment(date)
    }

    static getDaysSinceStart() {
        return moment().diff(EnergyCalculation.startDate, 'days')
    }

    static getMinutesSinceStart() {
        return moment().diff(EnergyCalculation.startDate, 'minutes')
    }

    static getSecoundsSinceStart() {
        return (moment().diff(EnergyCalculation.startDate, 'minutes') * 60 ) + moment().seconds()
    }

    static changeMonth(value) {
        this.startDate.add(value,'month')
    }

    /**
     * 
     * @param {*} value 
     */
    static setSoldSensorsPerDay(value) {
        EnergyCalculation.soldSensorsPerDay = value
    }

    /**
     * Berechnet wie viel Energie im Schnitt ein Sensor pro Jahr an Ernergie spart
     * @returns in Watt
     */
    static getYearSavingPerSensor() {
        if(EnergyCalculation.overwriteEnergySavingPerYear != null) {
            return parseFloat(EnergyCalculation.overwriteEnergySavingPerYear);
        }
        let energySavingPerSensor = 0
        for(let application of EnergyCalculation.applications) {
            let savedEnergy = application.electricPower * application.luminiaresPerSensor * application.burningTimePerYear * application.saving * application.weighting
            energySavingPerSensor += savedEnergy
        }
        return energySavingPerSensor
    }

        /**
     * Gibt zurück wie viel Ein Sensor pro Tag einspart
     * @returns in Watt
     */
    static getSavingWattPerDay() {
        return EnergyCalculation.getYearSavingPerSensor() / 365
    }

    /**
     * Gibt zurück wie viel Ein Sensor pro Minute einspart
     * @returns in Watt
     */
    static getSavingWattPerMinute() {
        return EnergyCalculation.getSavingWattPerDay() / 24 / 60
    }

    static getSavingWattPerSecound() {
        return EnergyCalculation.getSavingWattPerMinute() / 60
    }

    static getSoldSensorPerMinute() {
        return EnergyCalculation.soldSensorsPerDay / 24 / 60
    }

    static getSoldSensorPerSecound() {
        return EnergyCalculation.getSoldSensorPerMinute() / 60
    }

    static getSoldSensorsNow() {
        return EnergyCalculation.getDaysSinceStart() * EnergyCalculation.soldSensorsPerDay
    }

    static getSoldSensorsNowMinute() {
        return EnergyCalculation.getMinutesSinceStart() * EnergyCalculation.getSoldSensorPerMinute()
    }

    static getSoldSensorsNowSecound() {
        return EnergyCalculation.getSecoundsSinceStart() * EnergyCalculation.getSoldSensorPerSecound()
    }


    /**
     * 
     * @returns gibt zurück wie viele Watt bislang eingespart wurde auf Tag genau
     */
    static getSavingUnits() {
        const soldSensorsPerDay = EnergyCalculation.soldSensorsPerDay;
        const days = EnergyCalculation.getDaysSinceStart()
        return (days * soldSensorsPerDay * (days+1) / 2) * EnergyCalculation.getSavingWattPerDay()
    }

        /**
     * 
     * @returns gibt zurück wie viele Watt bislang eingespart wurde auf Sekunde genau
     */
        static getSavingUnitsPerMinute() {
            const soldSensorsPerMinute = EnergyCalculation.getSoldSensorPerMinute();
            const minutes = EnergyCalculation.getMinutesSinceStart()
            //console.log("Minuten "  + minutes)
            return (minutes * soldSensorsPerMinute * (minutes+1) / 2) * EnergyCalculation.getSavingWattPerMinute()
        }

                /**
     * 
     * @returns gibt zurück wie viele Watt bislang eingespart wurde auf Sekunde genau
     */
        static getSavingUnitsPerSecounds() {
            const soldSensorsPerSecounds = EnergyCalculation.getSoldSensorPerSecound();
            const secounds = EnergyCalculation.getSecoundsSinceStart()
            return (secounds * soldSensorsPerSecounds * (secounds+1) / 2) * EnergyCalculation.getSavingWattPerSecound()
        }

} 